import { TFunction } from 'i18next';

export const formatTime = (time: number): string => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;
    return [hours, minutes, seconds]
      .map(v => v < 10 ? "0" + v : v)
      .join(":");
  };

// Function to format age in months into a human-readable string
export const formatAge = (ageInMonths: number | null, t: TFunction<any, undefined>): string => {
  if (ageInMonths == null) {
    return "";
  }
  if (ageInMonths === 0) return t('age.newborn');
  if (ageInMonths === 0.23) return t('age.oneWeek');
  if (ageInMonths === 1) return t('age.oneMonth');
  if (ageInMonths === 2) return t('age.twoMonths');
  if (ageInMonths === 12) return t('age.oneYear');
  if (ageInMonths === 24) return t('age.twoYears');
  if (ageInMonths < 24){
    return ageInMonths + " " + t('age.months');
  }
  // Use Math.floor to ensure whole numbers for years
  return Math.floor(ageInMonths / 12)  + " " + t('age.years');
};
